import React from 'react';
import { useTranslation } from 'react-i18next';
import { findImage } from 'utils/Utils';

const RequestCompletePage = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="completed">
        <div className="middle">
          <div className="icon">
            <img src={findImage('success.png')} />
          </div>
          <div className="title">{t('request_complete')}</div>
          <div className="text" style={{ whiteSpace: 'pre-line' }}>
            {t('request_complete_message')}
            <br />
            {t('request_complete_confirmed')}
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestCompletePage;
